import { WebPortalService } from "../resource";

const ReportModule = {
  namespaced: true,
  state: {
    cdr: [],
    cdr_raw: [],
    dashboard: null,
    summary: null
  },
  mutations: {
    SET_CDR(state, data) {
      state.cdr = data;
    },
    SET_CDR_RAW(state, data) {
      state.cdr_raw = data;
    },
    SET_DASHBOARD(state, data) {
      state.dashboard = data;
    },
    SET_SUMMARY(state, data) {
      state.summary = data;
    }
  },
  actions: {
    clearReportCDRRaw({ commit, state }, params) {
      commit("SET_CDR_RAW", []);
    },
    clearReportCDR({ commit, state }, params) {
      commit("SET_CDR", []);
    },
    clearReportSummary({ commit, state }, params) {
      commit("SET_SUMMARY", null);
    },
    clearReportDashboard({ commit, state }, params) {
      commit("SET_DASHBOARD", null);
    },

    async listReportCDR({ commit, state }, params) {
      try {
        const resp = await WebPortalService.ReportCDRV3(params);
        let data = resp.data;
        console.log("data", data);
        console.log("datum", data.Data[0]);
        console.log("data_cdr", data.Data[0].records);
        console.log("data_cdr_raw", data.Data[0].record_raws);
        console.log("data_summary", data.Data[0].summaries_by_date);
        console.log("data_dashboard", data.Data[0].summaries);

        commit("SET_CDR", data.Data[0].records);
        commit("SET_CDR_RAW", data.Data[0].record_raws);
        commit("SET_SUMMARY", data.Data[0].summaries_by_date);
        commit("SET_DASHBOARD", data.Data[0].summaries);
      } catch (err) {
        console.log("err", err);
      }
    }
  },

  getters: {
    getReportCDR(state) {
      return state.cdr;
    },
    getReportCDRRaw(state) {
      return state.cdr_raw;
    },
    getReportSummary(state) {
      return state.summary;
    },
    getReportDashboard(state) {
      return state.dashboard;
    }
  }
};

export default ReportModule;
